module.exports = __webpack_public_path__ + "media/images/moodle_logo_square_36-77fd6776cfc1838f839cda67967db9e9.png";